module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-top-ties.fa2ef748.png";